import { useCallback, useEffect } from 'react';
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export var useEvent = function useEvent(eventName, callback) {
  useEffect(function () {
    if (!callback) {
      return;
    }

    var listener = function listener(event) {
      callback(event.detail); // Use `event.detail` for custom payloads
    };

    window.addEventListener(eventName, listener);
    return function () {
      window.removeEventListener(eventName, listener);
    };
  }, [callback, eventName]);
  var dispatch = useCallback(function (detail) {
    var event = new CustomEvent(eventName, {
      detail: detail
    });
    window.dispatchEvent(event);
  }, [eventName]); // Return a function to dispatch the event

  return {
    dispatch: dispatch
  };
};